import React from "react";

const DisclaimerModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      // className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/95 backdrop-blur-xl animate-in fade-in duration-300"
      className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/95 backdrop-blur-xl animate-in fade-in duration-300"
      style={{
        zIndex: "200"
        // width: "80%",
        // marginLeft: "auto",
        // marginRight: "auto",
        // marginTop: "8%",
      }}
    >
      {/* <div className="glass w-full h-full md:max-w-4xl md:max-h-[90vh] md:rounded-[3rem] overflow-hidden flex flex-col border-indigo-500/20 shadow-2xl"> */}
      <div className="glass w-full h-full md:max-w-4xl md:max-h-[90vh] rounded-[2rem] flex flex-col border-indigo-500/20 shadow-2xl">
        {/* Header */}
        <div className="px-6 py-4 md:px-10 md:py-8 border-b border-white/5 flex justify-between items-center bg-slate-900/40">
          <div className="flex items-center space-x-3">
            {/* <div className="w-8 h-8 md:w-10 md:h-10 bg-amber-600 rounded-xl flex items-center justify-center"> */}
            <div
              className="w-8 md:w-10 md:h-10 bg-amber-600 rounded-xl flex items-center justify-center"
              style={{ height: "35px" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                // className="h-5 w-5 md:h-6 md:w-6 text-white"
                className="w-5 md:h-6 md:w-6 text-white"
                style={{ height: "25px" }}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <div>
              <h2 className="text-xl md:text-3xl font-bold text-white tracking-tight">
                Fidelity Disclaimer
              </h2>
              <p className="text-[8px] md:text-xs text-amber-400 font-bold uppercase tracking-widest mt-0.5">
                AI Synthesis Limits
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 md:p-3 hover:bg-white/10 rounded-full transition-all group active:scale-95"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              // className="h-6 w-6 md:h-8 md:w-8 text-slate-400 group-hover:text-white"
              className="w-6 md:h-8 md:w-8 text-slate-400 group-hover:text-white"
              style={{ height: "30px" }}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div
          className="flex-1 p-6 md:p-10 bg-slate-950/20 custom-scrollbar space-y-8"
          style={{ overflowY: "auto", overscrollBehavior: "contain" }}
        >
          {/* <div
          className="flex-1 overflow-y-auto p-6 md:p-10 bg-slate-950/20 custom-scrollbar space-y-8"
          style={{ overflowY: "auto" }}
        > */}
          <section className="space-y-4" style={{ margin: "3%" }}>
            <h3 className="text-xl font-bold text-white flex items-center space-x-2">
              <span className="w-1.5 h-6 bg-indigo-500 rounded-full"></span>
              <span style={{ color: "white" }}>The Identity Fidelity Gap</span>
            </h3>
            <p className="text-slate-400 leading-relaxed">
              It is critical to understand that the output images generated by
              this tool **may not exactly match** the subject images you upload.
              While our engine uses advanced biometric preservation, AI
              synthesis is a generative process, not a simple photo filter.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              {/* <div className="bg-slate-900/50 p-5 rounded-2xl border border-white/5"> */}
              <div
                className="bg-slate-900/50 rounded-2xl border border-white/5"
                style={{ padding: "5%" }}
              >
                <h4 className="text-indigo-400 font-bold text-sm mb-2 uppercase tracking-wider">
                  Input Quality Factors
                </h4>
                <ul className="text-xs text-slate-500 space-y-2 list-disc pl-4">
                  <li>
                    **Resolution & Clarity:** Low-resolution or blurry source
                    photos provide insufficient biometric data for the AI to
                    reconstruct fine details.
                  </li>
                  <li>
                    **Lighting Conditions:** Harsh shadows or overexposure on
                    the face can lead to "hallucinations" where the AI tries to
                    guess missing features.
                  </li>
                  <li>
                    **Posture & Angle:** Subjects not facing the camera directly
                    (3/4 views or side profiles) are significantly harder to map
                    onto new environments.
                  </li>
                  <li>
                    **Selfies & Distortion:** While convenient, standard selfies
                    often suffer from lens distortion (making features appear
                    wider or closer than they are) and suboptimal angles.
                    Uploading a selfie and expecting a high-resolution studio
                    masterpiece may lead to disappointment, as the AI can only
                    reconstruct based on the geometric truth provided in the
                    source.
                  </li>
                  <li>
                    **Busy Backgrounds:** Complex backgrounds can bleed into the
                    subject's silhouette during the extraction phase, causing
                    artifacts.
                  </li>
                </ul>
              </div>
              {/* <div className="bg-slate-900/50 p-5 rounded-2xl border border-white/5"> */}
              <div
                className="bg-slate-900/50 rounded-2xl border border-white/5"
                style={{ padding: "5%" }}
              >
                <h4 className="text-indigo-400 font-bold text-sm mb-2 uppercase tracking-wider">
                  AI Technical Constraints
                </h4>
                <ul className="text-xs text-slate-500 space-y-2 list-disc pl-4">
                  <li>
                    **Latent Space Interpretation:** The AI "reimagines" your
                    face based on its training. It doesn't "copy-paste" pixels;
                    it reconstructs them.
                  </li>
                  <li>
                    **Diffusion Noise:** The generation process starts from
                    random noise. Small fluctuations can lead to variations in
                    eye color, skin texture, or bone structure.
                  </li>
                  <li>
                    **Biometric Complexity:** Human faces are incredibly unique.
                    Even a 1% shift in the distance between eyes can make a
                    person look "different" to the human brain.
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="space-y-4" style={{ margin: "3%" }}>
            <h3 className="text-xl font-bold text-white flex items-center space-x-2">
              <span className="w-1.5 h-6 bg-indigo-500 rounded-full"></span>
              <span style={{ color: "white" }}>
                User Controls & Originality
              </span>
            </h3>
            <p className="text-slate-400 leading-relaxed text-sm">
              Your choices in the tool directly impact how "original" the
              subject looks. Every modification is a trade-off between the
              source photo and the AI's generative capability.
            </p>
            <div className="bg-indigo-500/5 border border-indigo-500/10 p-6 rounded-3xl space-y-4">
              <div className="flex items-start space-x-4">
                <div
                  className="w-10 h-10 bg-indigo-600/20 rounded-lg flex-shrink-0 flex items-center justify-center text-indigo-400 font-bold"
                  style={{ margin: "3%" }}
                >
                  01
                </div>
                <div>
                  <h4 className="text-white font-bold text-sm">
                    Perspective & Expression Shifts
                  </h4>
                  <p className="text-xs text-slate-500 mt-1">
                    Using **Profile View** or **Professional Smile** overrides
                    forces the AI to warp the original facial structure. A
                    "Professional Smile" isn't just your mouth—it changes your
                    cheeks, eyes, and jawline, which can drift away from your
                    original identity.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div
                  className="w-10 h-10 bg-indigo-600/20 rounded-lg flex-shrink-0 flex items-center justify-center text-indigo-400 font-bold"
                  style={{ margin: "3%" }}
                >
                  02
                </div>
                <div>
                  <h4 className="text-white font-bold text-sm">
                    Snippet & Directive Interference
                  </h4>
                  <p className="text-xs text-slate-500 mt-1">
                    When you use the **Style Builder**, you are giving the AI
                    competing instructions. If a snippet shows a very specific
                    collar or heavy jewelry, the AI may prioritize replicating
                    those items over maintaining perfect facial fidelity.
                    **Global Text Directives** (like "Cinematic Lighting") also
                    alter how shadows fall on the face, which can change
                    perceived identity.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="space-y-4" style={{ margin: "3%" }}>
            <h3 className="text-xl font-bold text-white flex items-center space-x-2">
              <span className="w-1.5 h-6 bg-indigo-500 rounded-full"></span>
              <span style={{ color: "white" }}>
                The Indian Subject Challenge
              </span>
            </h3>
            <p className="text-slate-400 leading-relaxed text-sm">
              In our testing, we have observed that Indian subjects can be more
              challenging for AI models to replicate with 100% fidelity.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-3">
                <h4 className="text-amber-400 font-bold text-xs uppercase tracking-widest">
                  Why it's harder:
                </h4>
                <ul className="text-xs text-slate-500 space-y-2 list-disc pl-4">
                  <li>
                    **Training Bias:** Many global AI models have a slight
                    western-centric bias in their training data, leading to
                    subtle "westernization" of features.
                  </li>
                  <li>
                    **Complex Adornments:** Traditional Indian attire (Sarees,
                    Lehengas) and intricate jewelry (Maang Tikka, heavy
                    necklaces) create complex visual noise that the AI sometimes
                    struggles to separate from biometric features.
                  </li>
                  <li>
                    **Skin Tone Nuance:** The rich variety of Indian skin tones
                    requires precise lighting to avoid looking "flat" or "washed
                    out" in AI renders.
                  </li>
                </ul>
              </div>
              <div className="space-y-3">
                <h4 className="text-green-400 font-bold text-xs uppercase tracking-widest">
                  Best Practices for Indian Subjects:
                </h4>
                <ul className="text-xs text-slate-500 space-y-2 list-disc pl-4">
                  <li>
                    **High-Contrast Frontal Photos:** Use photos with clear,
                    direct lighting that defines the nose and jawline.
                  </li>
                  <li>
                    **Neutral Backgrounds:** Avoid busy patterns in the source
                    photo background.
                  </li>
                  <li>
                    **Decency Standards:** For Indian cultural attire (Sarees,
                    Lehengas), our AI is programmed to maintain high decency
                    standards. This includes ensuring the navel and midriff are
                    modestly covered, even if the reference image suggests
                    otherwise.
                  </li>
                  <li>
                    **Specific Cultural Prompts:** If wearing traditional
                    attire, use the **Global Text Directive** to specify the
                    style (e.g., "Maintain traditional Banarasi Saree texture")
                    to help the AI categorize the visual data.
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="space-y-4" style={{ margin: "3%" }}>
            <h3 className="text-xl font-bold text-white flex items-center space-x-2">
              <span className="w-1.5 h-6 bg-indigo-500 rounded-full"></span>
              <span style={{ color: "white" }}>Group Portrait Complexity</span>
            </h3>
            <p className="text-slate-400 leading-relaxed text-sm">
              The number of subjects in a single generation significantly
              impacts the AI's ability to maintain perfect originality for every
              individual.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div
                className="bg-slate-900/50 rounded-2xl border border-white/5"
                style={{ padding: "3%" }}
              >
                <h4 className="text-indigo-400 font-bold text-sm mb-2 uppercase tracking-wider">
                  Group Portrait Excellence
                </h4>
                <p className="text-xs text-slate-500 leading-relaxed">
                  Our tool is designed to produce **excellent family, friends,
                  and group portraits** for up to 5 subjects with high fidelity.
                  To achieve these stunning results, it is essential that
                  **high-quality source photos** are provided for **each
                  individual** subject.
                </p>
                <ul className="text-xs text-slate-500 mt-3 space-y-2 list-disc pl-4">
                  <li>
                    **Quality Dependency:** Without high-quality input for every
                    subject, the overall group portrait may lose some
                    originality and biometric precision.
                  </li>
                  <li>
                    **The Weakest Link Effect:** Even a **single low-quality
                    source image** can significantly degrade the quality and
                    realism of the entire group or family portrait.
                  </li>
                  <li>
                    **Optimal Results:** For the best group synthesis, ensure
                    every member's source photo is sharp, well-lit, and
                    high-resolution.
                  </li>
                </ul>
              </div>
              <div
                className="bg-slate-900/50 rounded-2xl border border-white/5"
                style={{ padding: "3%" }}
              >
                <h4 className="text-indigo-400 font-bold text-sm mb-2 uppercase tracking-wider">
                  Best Practices for Large Groups
                </h4>
                <ul className="text-xs text-slate-500 space-y-2 list-disc pl-4">
                  <li>
                    **Uniform Lighting:** Ensure all 5 source photos have
                    similar lighting directions. If one person has side-lighting
                    and others have frontal lighting, the AI may struggle to
                    unify them naturally.
                  </li>
                  <li>
                    **Clear Identifiers:** Use the **Identifier Labels** in the
                    Group Studio (e.g., "DAD", "SON") to help the AI anchor
                    specific biometric data to specific positions in the group.
                  </li>
                  <li>
                    **High-Res Sources:** For groups of 5, the "pixel budget"
                    per face is smaller. Using the highest resolution source
                    photos possible is mandatory for maintaining features.
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-amber-500/5 border border-amber-500/10 p-5 rounded-2xl mt-4">
              <h4 className="text-amber-400 font-bold text-xs uppercase tracking-widest mb-2 flex items-center space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
                <span>Compositional Integrity & Reference Leakage</span>
              </h4>
              <p className="text-xs text-slate-500 leading-relaxed">
                Despite our advanced architectural safeguards, in rare technical
                edge cases, figures from a reference image may inadvertently
                manifest in the final group portrait. This phenomenon, known as
                "reference leakage," can occur due to ambiguous mapping,
                non-existent identifiers, or complex subject arrangements in the
                source reference. While we have implemented strict controls to
                mitigate these anomalies, they may occasionally bypass these
                safeguards. We recommend thorough verification of your mapping
                configurations to ensure the highest level of compositional
                accuracy.
              </p>
            </div>
          </section>

          <section
            className="bg-indigo-600/10 border border-indigo-500/20 rounded-[2.5rem] text-center"
            style={{ padding: "5%", margin: "3%" }}
          >
            <h3 className="text-2xl font-bold text-white mb-4">
              Why use this tool?
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Despite the challenges mentioned above, our extensive testing has
              shown impressive results across various scenarios—whether for
              individuals, couples, or groups of up to 5 subjects. You don't
              need a high-end professional camera; a modern smartphone is more
              than capable of providing the high-quality input needed for
              stunning outputs. We have even tested extensively with Indian
              subjects and achieved thoroughly satisfying results when provided
              with good quality source images.
              <br />
              <br />
              Furthermore, this tool is powered by **Gemini 3 Pro**, widely
              recognized as the most advanced image generation model available
              today—a fact even our rivals have acknowledged. This cutting-edge
              technology offers **unprecedented creative freedom**, allowing you
              to place yourself in environments that would otherwise cost
              thousands to shoot—from **luxury yachts** to **high-end studio
              setups**.
              <br />
              <br />
              The **Style Builder** lets you experiment with fashion and jewelry
              you don't even own yet, serving as the ultimate "What If" engine
              for your professional and personal brand.
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              <span className="px-4 py-2 bg-slate-900 rounded-full text-[10px] font-bold text-indigo-400 border border-white/5 uppercase tracking-widest">
                Yachts & Boats
              </span>
              <span className="px-4 py-2 bg-slate-900 rounded-full text-[10px] font-bold text-indigo-400 border border-white/5 uppercase tracking-widest">
                Supercars & Bikes
              </span>
              <span className="px-4 py-2 bg-slate-900 rounded-full text-[10px] font-bold text-indigo-400 border border-white/5 uppercase tracking-widest">
                High-End Jewelry & Clothing
              </span>
              <span className="px-4 py-2 bg-slate-900 rounded-full text-[10px] font-bold text-indigo-400 border border-white/5 uppercase tracking-widest">
                High-End Studio Settings
              </span>
              <span className="px-4 py-2 bg-slate-900 rounded-full text-[10px] font-bold text-indigo-400 border border-white/5 uppercase tracking-widest">
                Global Locations
              </span>
            </div>
            <p className="mt-8 text-xs text-indigo-300 font-bold italic">
              Pro Tip: To keep maximum originality, use a high-quality,
              front-facing photo with neutral lighting and keep your
              "Expression" and "Posture" settings to "Original".
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="px-6 py-6 md:px-10 md:py-8 border-t border-white/5 bg-slate-900/80 flex justify-center">
          <button
            onClick={onClose}
            className="w-full md:w-auto px-12 py-4 bg-indigo-600 hover:bg-indigo-500 text-white font-black text-xs tracking-[0.2em] rounded-2xl shadow-xl shadow-indigo-600/20 active:scale-95 transition-all"
          >
            I UNDERSTAND
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;
